import React, {useEffect, useState} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import config from "../../Helpers/config";
import axios from "axios";
import {history} from '../../Helpers/history';
import {errorMessages} from "../../Helpers/ErrorMessages";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import Card from "@material-ui/core/Card";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Label from "../../Utils/FormInputs/Label";
import Col from "react-bootstrap/Col";
import TextField from "../../Utils/FormInputs/TextField";
import {convertDate} from "../../Utils/titleCaseFunction";
import Textarea from "../../Utils/FormInputs/Textarea";
import InvoicePrintDialog from "../Invoice/InvoicePrintDialog";
import { RightAlignedContainer } from '../../Utils/styledComponents';


const CustomerReturnInvoice = ({actions, snackbars, match: {params}}) => {
    const {invoice_no} = params;
    const [rows, setRows] = useState([]);
    const [data, setData] = useState({});
    const [totals, setTotals] = useState({total_discount: 0, grand_total_price: 0});
    const [state, setState] = useState({customer_name: '', date: '', customer_id: '', invoice_id: ''});
    const [details, setDetails] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [receipt_no, setReceiptNo] = useState('');
    const [openDialog, setOpenDialog] = useState(false);


    useEffect(() => {
        if (!invoice_no){
            return
        }
        const formData = new FormData();
        formData.append('invoice_no', invoice_no);
        axios.post(`${config.epharmUrl}/Creturn/invoice_return_form`, formData).then(response => {
            const data = response.data;
            const dt = !data ? {} : data;
            setData(dt)
        }).catch((err) => {
            errorMessages(err, null, actions)
        })
    }, [invoice_no])

    useEffect(() => {
        const {invoice_all_data, customer_name, invoice_id, customer_id, date} = data;
        const invoiceArr = invoice_all_data ?? []
        const arr = invoiceArr.map(item => ({
            ...item, product_quantity: '', total: 0,
            rtn: false, discount: ''
        }))
        setState({
            customer_name: customer_name ?? '',
            invoice_id: invoice_id ?? '',
            customer_id: customer_id ?? '',
            date: date ?? ''
        })
        setRows(arr)
    }, [data])

    const handleChangeDetails = event => {
        setDetails(event.target.value)
    };

    const calculateTotal = (item) => {
        return +(item.product_quantity) * +item.rate;
    };

    const calculateDiscount = (item) => {
        let discount_value = !item.discount ? 0 : item.discount;
        let val = +(discount_value) / 100;
        return calculateTotal(item) * val;
    };

    const calculateTotalAmount = (arr) => {
        let total_discount = arr.reduce((acc, row) => {
            const discount = !row.discount ? 0 : row.discount;
            const product_quantity = !row.product_quantity ? 0 : row.product_quantity;
            const total = product_quantity * row.rate;
            const val = total * discount / 100;
            return acc + val
        }, 0);
        let grand_total_price = arr.reduce((acc, row) => {
            const dt = row.total ? row.total : 0
            return acc + dt;
        }, 0);
        setTotals({total_discount, grand_total_price});
    };

    const calculateFinalTotal = (item) => {
        return calculateTotal(item) - calculateDiscount(item);
    };


    const changeCheckValue = (e, idx) => {
        const {checked} = e.target;
        const arr = rows.map((item, index) => {
            if (index === idx) {
                return {...item, rtn: checked, total: calculateFinalTotal(item)}
            }
            return item
        })
        calculateTotalAmount(arr);
        setRows(arr)
    };


    const handleChangeQuantity = (event, index) => {
        const {value} = event.target;
        const arr = rows.map((item, idx) => {
            if (idx === index) {
                return {
                    ...item,
                    product_quantity: value,
                    total: calculateFinalTotal({
                        rate: item.rate, product_quantity: value, discount: item.discount
                    })
                }
            }
            return item
        })
        calculateTotalAmount(arr);
        setRows(arr)
    };

    const handleChangeDiscount = (event, idx) => {
        const {value} = event.target;
        const arr = rows.map((item, index) => {
            if (index === idx) {
                return {
                    ...item,
                    discount: value,
                    total: calculateFinalTotal({
                        rate: item.rate,
                        product_quantity: item.product_quantity,
                        discount: value
                    })
                }
            }
            return item
        })
        calculateTotalAmount(arr);
        setRows(arr)
    };

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    const handleCancel = () =>{
        history.push('/stockreturnlist')
    }

    const handleOpenReceipt = () =>{
        history.push(`/stockreturndetails/${receipt_no}`)
    }


    const handleSubmitReturn = (event) => {
        event.preventDefault();
        const {invoice_id, customer_id, date} = state
        const {total_discount, grand_total_price} = totals;
        const arr =  rows.filter(item => item.rtn).map(item=>({
            product_id:item.product_id, sold_qty: +item.quantity, product_quantity: +item.product_quantity,
            product_rate: +item.rate, total_price: +item.total, discount: +item.discount, batch_id:item.batch_id,
            tax:0
        }))
        const checked = rows.some(item => item.rtn);
        const required = rows.filter(item => item.rtn).every(row => row.product_quantity && row.product_quantity <= row.quantity)
        setSubmitted(true)

        const params = {invoice_id, customer_id, invoice_date:date, payment_type:'',total_discount, details, total_tax:0,
        grand_total_price, products:arr}
        if (checked && required) {
            setIsSubmitted('pending')
            axios.post(`${config.epharmUrl}/Creturn/return_invoice`, params).then(response => {
                const data = response.data;
                const dt = data ?? '';
                setIsSubmitted('resolved')
                actions.snackbarActions.successSnackbar('Product(s) successfully returned')
                setReceiptNo(dt)
                setOpenDialog(true)
            }).catch(err => {
                setIsSubmitted('rejected')
                errorMessages(err, null, actions)
            });
        }
    }

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackBar()
    }




    const {message, variant, open} = snackbars;
    const {customer_name, date} = state;
    const {total_discount, grand_total_price} = totals;
    const disabled = rows?.some(item => item.rtn);
    return (
        <div className='journals'>
            <ReusableDashboardHeader component='Return to Customer' heading="Return"
                                     subHeading='Return to Customer' link={history.location.pathname}/>
            <Card className="p-3">
                <InvoicePrintDialog openDialog={openDialog} handleCloseDialog={handleCloseDialog}
                                     message="Receipt" text='receipt'>
                    <RightAlignedContainer>
                        <button onClick={handleOpenReceipt} type="button" className="btn pharmacy-info-btn mr-3">Yes</button>
                        <button onClick={handleCancel} type="button" className="btn pharmacy-grey-btn ">No</button>
                    </RightAlignedContainer>                
                </InvoicePrintDialog>
                <PharmacySnackbar open={open} message={message} variant={variant}
                                  handleCloseBar={closeSnackbar}/>
                <form onSubmit={handleSubmitReturn} autoComplete='off'>
                    <div className="row">
                        <div className="col-md-5">
                            <Form.Group as={Row}>
                                <Label column sm={3} name="Customer Name"/>
                                <Col sm={6}>
                                    <TextField type="text" value={customer_name} readOnly/>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Label column sm={3} name='Date'/>
                                <Col sm={6}>
                                    <TextField type="text" value={convertDate(date)} readOnly/>
                                </Col>
                            </Form.Group>
                        </div>
                        <div className="col-md-7"/>
                    </div>
                    <div className="">
                        <table className="table table-bordered  custom-bordered-table">
                            <thead>
                            <tr>
                                <th>Product</th>
                                <th>Batch#</th>
                                <th>Sold Quantity</th>
                                <th>Return Quantity<span className='invalid-text'>*</span></th>
                                <th>Unit Price</th>
                                <th>Discount &#37;</th>
                                <th>Total</th>
                                <th>Check Return</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rows.map((row, idx) => (
                                <tr key={row.invoice_detail_id}>
                                    <td>
                                        {row.product_name}
                                    </td>
                                    <td>
                                        {row.batch_id}
                                    </td>
                                    <td>
                                        {row.quantity}
                                    </td>
                                    <td>
                                        <TextField submitted={submitted} type="number" value={row.product_quantity} min="0"
                                                   onChange={(e) => handleChangeQuantity(e, idx)}/>
                                        {submitted && !row.product_quantity ?
                                            <div className="invalid-text">Quantity is required</div> :
                                            (row.product_quantity && row.product_quantity > row.quantity) ?
                                                <div className="invalid-text">You can only return up
                                                    to {row.quantity}</div> : null}
                                    </td>
                                    <td>
                                        {row.rate}
                                    </td>
                                    <td>
                                        <TextField type="number" value={row.discount}
                                                   name="discount" min="0"
                                                   onChange={(e) => (handleChangeDiscount(e, idx))}/>

                                    </td>
                                    <td>
                                        {row.total}
                                    </td>
                                    <td>
                                        <Form.Check type="checkbox"
                                                    vlaue={row.rtn}
                                                    name="rtn"
                                                    onChange={(e) => changeCheckValue(e, idx)}
                                                    style={{transform: "scale(1)"}}
                                        />
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan={4} rowSpan={2}>
                                    <Textarea name="details" value={details}
                                              onChange={handleChangeDetails}/>
                                </td>
                                <td className="text-right">
                                    Total Deduction:
                                </td>
                                <td>
                                    {total_discount}
                                </td>
                                <td/>
                            </tr>
                            <tr>
                                <td className="text-right">
                                    Total Return
                                </td>
                                <td>
                                    {grand_total_price}
                                </td>
                                <td/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <button disabled={!(isSubmitted === 'pending' || disabled)}
                            className="float-right btn pharmacy-btn btn-sm">{isSubmitted === 'pending' ? 'Submitting...' : 'Submit'}</button>
                </form>
            </Card>
        </div>
    );

}

function mapStateToProps(state) {
    return {
        snackbars: state.snackbars
    }

}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerReturnInvoice);